import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FormModal from 'components/shared/modal/FormModal';
import Button, {
  BUTTON_TYPES,
  BUTTON_COLORS,
} from 'components/shared/button/Button';
import './AddProjectReportLog.css';

class ProjectReportPublishModal extends Component {
  render() {
    const { show, onClose, onConfirm } = this.props;
    return (
      <FormModal
        id="project-report-save-draft-modal"
        className="project-report-save-draft-modal-view"
        show={show}
        onClose={onClose}
        subTitle="Publish Report"
      >
        <div className="modal-body-section">
          <div className="text-section">
            Revisions are not permissible once this report has been formally
            submitted. Please confirm you are ready to issue the record
            document.
          </div>
          <div className="buttons-section">
            <Button
              key="disgard-button"
              type={BUTTON_TYPES.CONFIRMATION}
              color={BUTTON_COLORS.WHITE}
              label="Cancel"
              onClick={onClose}
            />
            <div className="buttons-separate" />
            <Button
              key="save-draft-button"
              type={BUTTON_TYPES.CONFIRMATION}
              color={BUTTON_COLORS.GREEN}
              label="Publish"
              onClick={onConfirm}
            />
          </div>
        </div>
      </FormModal>
    );
  }
}

ProjectReportPublishModal.propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
};

ProjectReportPublishModal.defaultProps = {
  show: false,
  onClose: () => null,
  onConfirm: () => null,
};

export default ProjectReportPublishModal;
